import { render } from "./CompanyList.vue?vue&type=template&id=4fbbc1b4&scoped=true&ts=true"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"

import "./CompanyList.vue?vue&type=style&index=0&id=4fbbc1b4&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fbbc1b4"]])

export default __exports__